// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Swiper from './third/swiper-bundle.min';

export default class GallerySwiper extends WebComponent {
	swiperInstance: ?any;

	didMount() {
	  const swiperEl = this.element;
	  if (!swiperEl) {
	    console.warn('GallerySwiper: Element .swiper nebyl nalezen v DOM');
	    return;
	  }

	  this.swiperInstance = new Swiper(swiperEl, {
	    direction: 'horizontal',
	    loop: false,
	    slidesPerView: 2,
	    slidesPerGroup: 1,
	    spaceBetween: 0,
	    navigation: {
	      nextEl: swiperEl.querySelector('.swiper-button-next'),
	      prevEl: swiperEl.querySelector('.swiper-button-prev'),
	    },
	  });
	}

	willUnmount() {
	  if (this.swiperInstance) {
	    this.swiperInstance.destroy(true, true);
	    this.swiperInstance = null;
	  }
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GallerySwiper.js